export default {
      id: "icon-rdv-usage",
      viewBox: "0 0 46 43",
      url: "../icon/" + "icons.svg#icon-rdv-usage",
      toString: function () {
        return this.url;
      }
    }